export default {
  data () {
    return {

    }
  },
  methods: {
    fetchCasinoGames (filter) {
      return this.$http.get(api+'api/v1/casino/games?_='+(new Date().getTime()), {
        params: filter,
      })
    },
    getGameFormById (id) {
      return this.$http.get(api + 'api/v1/casino/game/edit/'+id, {
        params: {id: id},
      })
    },
    saveGameForm (d, id) {
      return this.$http.post(api+'api/v1/casino/game/edit/'+id, d)
    },
    getProviderFormById (id) {
      return this.$http.get(api + 'api/v1/casino/provider/edit/'+id, {
        params: {id: id},
      })
    },
    saveProviderForm (d, id) {
      return this.$http.post(bsapi+'api/v1/casino/provider/edit/'+id, d)
    },
    setGameStatus(id, status) {
      return this.$http.post(api+'api/v1/casino/game/set_status/'+id, {status: status})
    },
    setProviderStatus(id, status) {
      return this.$http.post(api+'api/v1/casino/provider/set_status/'+id, {status: status})
    },
    getProviders () {
      return this.$http.get(api + 'api/v1/casino/providers')
    },
    getCategories () {
      return this.$http.get(bsapi + 'api/v1/casino/categories?_='+(new Date().getTime()))
    },
  }
}



// WEBPACK FOOTER //
// ./src/mixins/casino.js